<div class="svi-answer-option-item" [style.background-color]="isSelected('candidate') ? color : ''">
  <div *ngIf="showLabel" class="label">{{label}}</div>
  <div *ngIf="isSelected('candidate')" class="candidate-overlay"></div>
  <i *ngIf="isSelected('voter')" class="fa fa-user-circle voter-icon"></i>
</div>